
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function RequireJefatura({ children }) {
  const [loading, setLoading] = useState(true);
  const [isJefatura, setIsJefatura] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();

    const verificarJefatura = async () => {
      try {
        const API_URL = (
          import.meta.env.VITE_API_URL || "http://localhost:8000"
        ).replace(/\/$/, "");

        const response = await fetch(`${API_URL}/api/me/`, {
          credentials: "include",
          signal: controller.signal,
          cache: "no-store",
        });

        if (!response.ok) {
          setIsJefatura(false);
          return;
        }

        const data = await response.json();
        const funcionario = data?.funcionario;

        // El cargo se verifica con el servidor, no con localStorage.
        setIsJefatura(
          Boolean(funcionario?.id && funcionario.cargo === "jefatura")
        );
      } catch (error) {
        if (error.name !== "AbortError") {
          setIsJefatura(false);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    verificarJefatura();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (!loading && !isJefatura) {
      navigate("/", { replace: true });
    }
  }, [loading, isJefatura, navigate]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "2rem",
        }}
      >
        <span>Verificando permisos…</span>
      </div>
    );
  }

  if (!isJefatura) {
    return null;
  }

  return children;
}
